import { useEffect } from "react";
import { useGame } from "../store/game";

const POLL_MS = 1000;

type PriceTick = { price: number; timestamp: number };

/**
 * Polls /api/price every second and feeds the store. Uses a relative URL so
 * the Vite dev proxy (dev) or reverse proxy (prod) routes it to the backend.
 * Phase 3 will upgrade this to a push feed (SSE/WS).
 */
export function usePrice(): void {
  const setPrice = useGame((s) => s.setPrice);

  useEffect(() => {
    let cancelled = false;
    let timer: ReturnType<typeof setTimeout> | null = null;

    const apiUrl = import.meta.env.VITE_API_URL || "";

    const tick = async () => {
      try {
        const res = await fetch(`${apiUrl}/api/price`, { cache: "no-store" });
        if (res.ok) {
          const data = (await res.json()) as PriceTick;
          if (!cancelled && Number.isFinite(data.price)) setPrice(data.price);
        }
      } catch {
        /* transient — preserve last tick */
      }
      if (!cancelled) timer = setTimeout(tick, POLL_MS);
    };
    void tick();

    return () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
    };
  }, [setPrice]);
}
